<ui-notification [uuid]="uuid()" [duration]="duration()" color="success">
  <ng-icon name="heroCheckCircle" size="24" class="!block size-6" slot="icon" />

  <p class="text-sm font-medium">
    {{ title() }}
  </p>
  @if (subtitle()) {
    <p class="mt-1 text-sm">
      {{ subtitle() }}
    </p>
  }
</ui-notification>
